{
  ". Le contenu de la page de destination sera remplacé.": ". Se reemplazará el contenido de la página de destino.",
  "« {{part}} » : plage inversée": "« {{part}} »: intervalo invertido",
  "« {{part}} » n'est pas valide": "« {{part}} » no es válido",
  "« {{title}} » sera supprimée définitivement.": "« {{title}} » se eliminará definitivamente.",
  "(4 pages supplémentaires = +{{price}}€ par Yearbook)": "(4 páginas adicionales = +{{price}} € por yearbook)",
  "(facultatif)": "(opcional)",
  "(La modification de l'album remplacera la mise en page actuelle)": "(Modificar el álbum reemplazará el diseño actual)",
  "(pas floues ou pixellisées)": "(sin desenfoque ni pixelado)",
  "(vide)": "(vacío)",
  "{{count}} élève_one": "{{count}} alumno",
  "{{count}} élève_other": "{{count}} alumnos",
  "{{count}} étoile_one": "{{count}} estrella",
  "{{count}} étoile_other": "{{count}} estrellas",
  "{{count}} mot non placé : {{words}}_one": "No se pudo colocar {{count}} palabra: {{words}}",
  "{{count}} mot non placé : {{words}}_other": "No se pudieron colocar {{count}} palabras: {{words}}",
  "{{count}} mot_one": "{{count}} palabra",
  "{{count}} mot_other": "{{count}} palabras",
  "{{count}} page nécessaire_one": "{{count}} página necesaria",
  "{{count}} page nécessaire_other": "{{count}} páginas necesarias",
  "{{count}} page utilisée_one": "{{count}} página utilizada",
  "{{count}} page utilisée_other": "{{count}} páginas utilizadas",
  "{{count}} page visible_one": "{{count}} página visible",
  "{{count}} page visible_other": "{{count}} páginas visibles",
  "{{count}} pages": "{{count}} páginas",
  "{{count}} personne par page_one": "{{count}} persona por página",
  "{{count}} personne par page_other": "{{count}} personas por página",
  "{{count}} photo sélectionnée_one": "{{count}} foto seleccionada",
  "{{count}} photo sélectionnée_other": "{{count}} fotos seleccionadas",
  "{{count}} photo_one": "{{count}} foto",
  "{{count}} photo_other": "{{count}} fotos",
  "{{count}} repère déjà placé_one": "{{count}} guía ya colocada",
  "{{count}} repère déjà placé_other": "{{count}} guías ya colocadas",
  "{{count}} résultat_one": "{{count}} resultado",
  "{{count}} résultat_other": "{{count}} resultados",
  "{{count}} Yearbook_one": "{{count}} yearbook",
  "{{count}} Yearbook_other": "{{count}} yearbooks",
  "{{done}} / {{total}} remarques traitées": "{{done}} / {{total}} comentarios resueltos",
  "{{first}} ou {{last}} pages": "{{first}} o {{last}} páginas",
  "{{first}} ou {{last}} pages utilisées": "{{first}} o {{last}} páginas utilizadas",
  "{{sent}} / {{total}} photos envoyées": "{{sent}} / {{total}} fotos enviadas",
  "*La couverture doit mesurer 430×307 mm. En JPG ou PNG avec une résolution de 300 dpi. Il s'agit d'un format A3 paysage avec 5 mm de fond perdu nécessaires pour l'impression.": "*La portada debe medir 430×307 mm, en JPG o PNG a 300 dpi. Es un formato A3 horizontal con los 5 mm de sangrado necesarios para imprimir.",
  "*Les images/PDF doivent faire 220x307mm (soit un A4 + 10mm de marge) en résolution 300dpi. Les marges seront coupées à l'impression": "*Las imágenes/PDF deben medir 220×307 mm (A4 + 10 mm de margen) a 300 dpi. Los márgenes se recortarán al imprimir",
  "← Revenir à la sélection": "← Volver a la selección",
  "+ de couleurs": "Más colores",
  "❤️ Favoris": "❤️ Favoritos",
  "⭐ Recommandé": "⭐ Recomendados",
  "💡 Cliquez sur l'emplacement précis de la page où vous souhaitez ajouter votre remarque": "💡 Haz clic en el lugar exacto de la página donde quieras añadir tu comentario",
  "📁 Mes couvertures": "📁 Mis portadas",
  "📁 Mes fonds": "📁 Mis fondos",
  "📁 Mes modèles": "📁 Mis plantillas",
  "📖 Liseuse interactive – Utilisez les flèches ← → ou cliquez pour tourner les pages": "📖 Lector interactivo – Usa las flechas ← → o haz clic para pasar las páginas",
  "1er de couv": "Portada",
  "1ère de couv.": "Portada",
  "1ère de couverture": "Portada",
  "2ème de couv": "Interior de portada",
  "2ème de couverture": "Interior de portada",
  "3ème de couverture": "Interior de contraportada",
  "4ème de couv.": "Contraportada",
  "4ème de couverture": "Contraportada",
  "À faire ({{count}})": "Pendientes ({{count}})",
  "À l'attention de": "A la atención de",
  "À l'école": "En el centro",
  "À partir de": "Desde",
  "À placer": "Por colocar",
  "À propos de vous": "Sobre ti",
  "Accès enregistrés": "Accesos guardados",
  "Accès utilisateur": "Acceso de usuarios",
  "Adresse de livraison": "Dirección de entrega",
  "Adresse email invalide": "Dirección de email no válida",
  "Affichage": "Visualización",
  "Afficher": "Mostrar",
  "Afficher le panneau": "Mostrar panel",
  "Afficher les commentaires ({{count}})": "Mostrar comentarios ({{count}})",
  "Afficher ou masquer le chemin de fer": "Mostrar u ocultar el plan de páginas",
  "Afficher uniquement les pages :": "Mostrar solo estas páginas:",
  "Afin de toujours mieux vous accompagner, partagez-nous votre expérience": "Para ayudarnos a acompañarte mejor, comparte tu experiencia con",
  "Agrandir le zoom": "Acercar",
  "Ajout d'un ou plusieurs fonds de page": "Añadir uno o varios fondos de página",
  "Ajout du trombi dans le yearbook": "Añadir la orla al yearbook",
  "Ajouter": "Añadir",
  "Ajouter au panier": "Añadir a la cesta",
  "Ajouter aux favoris": "Añadir a favoritos",
  "Ajouter des pages": "Añadir páginas",
  "Ajouter des pages pour aérer mon Yearbook !": "¡Añadir páginas para dar más espacio a mi yearbook!",
  "Ajouter et continuer": "Añadir y continuar",
  "Ajouter et continuer (Shift+Entrée)": "Añadir y continuar (Mayús+Intro)",
  "Ajouter et fermer": "Añadir y cerrar",
  "Ajouter et fermer (Entrée)": "Añadir y cerrar (Intro)",
  "Ajouter ma propre couverture": "Añadir mi propia portada",
  "Ajouter un commentaire": "Añadir un comentario",
  "Ajouter un fichier": "Añadir un archivo",
  "Ajouter un mot": "Añadir una palabra",
  "Ajouter un QR Code": "Añadir un código QR",
  "Ajouter un repère": "Añadir una guía",
  "Ajouter un texte": "Añadir texto",
  "Ajouter une adresse email…": "Añadir una dirección de email…",
  "Ajouter une classe": "Añadir una clase",
  "Ajouter une couleur": "Añadir un color",
  "Ajouter une étape": "Añadir una etapa",
  "Ajouter une précision…": "Añadir una aclaración…",
  "Ajouter une section": "Añadir una sección",
  "Ajouter vos photos": "Añade tus fotos",
  "Album": "Álbum",
  "Album Magique": "Álbum mágico",
  "Annuler": "Cancelar",
  "Annuler (Ctrl+Z)": "Deshacer (Ctrl+Z)",
  "Aperçu": "Vista previa",
  "Appliquer": "Aplicar",
  "Appliquer à toutes les pages": "Aplicar a todas las páginas",
  "Après la page": "Después de la página",
  "Aucun album ne correspond à « {{query}} »": "Ningún álbum coincide con « {{query}} »",
  "Aucun destinataire disponible.": "No hay destinatarios disponibles.",
  "Aucun échange pour le moment.": "Aún no hay intercambios.",
  "Aucun favori pour le moment.": "Aún no hay favoritos.",
  "Aucun fond disponible.": "No hay fondos disponibles.",
  "Aucun fond personnalisé.": "No hay fondos personalizados.",
  "Aucun fond recommandé pour le moment.": "Aún no hay fondos recomendados.",
  "Aucun historique disponible pour cette page.": "No hay historial disponible para esta página.",
  "Aucun modèle de couverture disponible.": "No hay plantillas de portada disponibles.",
  "Aucun modèle disponible pour cette sélection.": "No hay plantillas disponibles para esta selección.",
  "Aucun modèle disponible.": "No hay plantillas disponibles.",
  "Aucun modèle personnel. Créez-en un depuis le menu « ... » d'une page.": "No hay plantillas personales. Crea una desde el menú « ... » de una página.",
  "Aucun mot n’a pu être placé.": "No se pudo colocar ninguna palabra.",
  "Aucun QR Code disponible.": "No hay códigos QR disponibles.",
  "Aucun résultat pour « {{query}} ».": "No hay resultados para « {{query}} ».",
  "Aucun sticker disponible.": "No hay stickers disponibles.",
  "Aucun utilisateur": "No hay usuarios",
  "Aucune": "Ninguna",
  "Aucune classe trouvée.": "No se han encontrado clases.",
  "Aucune couleur favorite. Ajoutez-en depuis le panneau Texte.": "No hay colores favoritos. Añádelos desde el panel Texto.",
  "Aucune couverture personnalisée.": "No hay portadas personalizadas.",
  "Aucune grille pour le moment.": "Aún no hay crucigramas.",
  "Aucune page à afficher.": "No hay páginas para mostrar.",
  "Aucune page générée. Veuillez réessayer.": "No se ha generado ninguna página. Inténtalo de nuevo.",
  "Aucune remarque validée.": "No hay comentarios validados.",
  "Aucune remarque.": "No hay comentarios.",
  "Avant d'ajouter votre Yearbook au panier, vérifiez bien les points suivants :": "Antes de añadir tu yearbook al carrito, comprueba lo siguiente:",
  "Avant de confirmer l'envoi de votre Yearbook en vérification auprès des graphistes, vérifiez bien les points suivants :": "Antes de enviar tu yearbook a los diseñadores para revisión, comprueba lo siguiente:",
  "Avis Google": "Opinión en Google",
  "Bas": "Abajo",
  "Bloquer des pages": "Bloquear páginas",
  "Bouche à oreille": "Boca a boca",
  "Carré": "Cuadrado",
  "Cela permettra à nos graphistes de prendre connaissance de vos remarques": "Así nuestros diseñadores podrán revisar tus comentarios",
  "Cercle": "Círculo",
  "Cette action est définitive et ne peut pas être annulée.": "Esta acción es definitiva y no se puede deshacer.",
  "Cette action est définitive.": "Esta acción es definitiva.",
  "Cette action est définitive. Le fond sera retiré de vos fonds personnalisés.": "Esta acción es definitiva. El fondo se eliminará de tus fondos personalizados.",
  "Cette action est irréversible. La photo sera définitivement supprimée.": "Esta acción es irreversible. La foto se eliminará definitivamente.",
  "Cette adresse est déjà ajoutée": "Esta dirección ya se ha añadido",
  "Chargement de l'album…": "Cargando álbum…",
  "Chargement de l'historique…": "Cargando historial…",
  "Chargement…": "Cargando…",
  "Chemin de fer": "Plan de páginas",
  "Chez un particulier": "A un particular",
  "Choisir": "Elegir",
  "Choisir un album…": "Elegir un álbum…",
  "Choisir un dossier": "Elegir una carpeta",
  "Choisir un fichier": "Elegir un archivo",
  "Choisir un thème…": "Elegir un tema…",
  "Choisir une couleur": "Elegir un color",
  "Choisir une ou plusieurs images": "Elegir una o varias imágenes",
  "Choisir une photo": "Elegir una foto",
  "Choisissez la page à intervertir avec": "Elige la página para intercambiar con",
  "Choisissez la page de destination où dupliquer": "Elige la página de destino para duplicar",
  "Choisissez le format et le nombre de pages souhaités.": "Elige el formato y el número de páginas.",
  "Choisissez un style de remplissage": "Elige un estilo de distribución de fotos",
  "Choisissez une méthode": "Elige un método",
  "Choisissez une version pour restaurer le contenu de la page.": "Elige una versión para restaurar el contenido de la página.",
  "Choix de la page": "Elegir una página",
  "Choix du modèle": "Elegir una plantilla",
  "Choix du nombre de personnes par page": "Elegir el número de personas por página",
  "Choix par nombre de personnes": "Elegir por número de personas",
  "Classiques": "Clásicas",
  "Client": "Cliente",
  "Cliquez ensuite sur la photo concernée dans la page": "Después haz clic en la foto afectada de la página",
  "Cliquez sur la page pour placer votre commentaire": "Haz clic en la página para colocar tu comentario",
  "Cliquez sur la photo pixelisée dans la page": "Haz clic en la foto pixelada de la página",
  "Cliquez sur le bandeau au-dessus d’une page pour lui donner une section.": "Haz clic en la franja sobre una página para asignarle una sección.",
  "Code postal": "Código postal",
  "Comment avez-vous connu 1Year1Book ?": "¿Cómo conociste 1Year1Book?",
  "Commentaire": "Comentario",
  "Commentaire de {{author}}": "Comentario de {{author}}",
  "Configurez votre album et laissez la magie opérer !": "¡Configura tu álbum y deja que actúe la magia!",
  "Confirmation de commande": "Confirmación del pedido",
  "Correct": "Aceptable",
  "Couleur de fond": "Color de fondo",
  "Couleur de la forme": "Color de la forma",
  "Couleur du nom": "Color del nombre",
  "Couleur du sticker": "Color del sticker",
  "Couleur du texte": "Color del texto",
  "Couleurs": "Colores",
  "Couleurs personnalisables": "Colores personalizables",
  "Couv.": "Portada",
  "Couverture": "Portada",
  "Couverture envoyée": "Portada enviada",
  "Couvertures": "Portadas",
  "Créatifs": "Creativas",
  "Création…": "Creando…",
  "Créer": "Crear",
  "Créer le modèle": "Crear la plantilla",
  "Créer mon album": "Crear mi álbum",
  "Créer un modèle": "Crear una plantilla",
  "Créer un nouveau dossier": "Crear una nueva carpeta",
  "Créez une nouvelle classe pour le trombinoscope.": "Crea una nueva clase para la orla.",
  "Créez une page unique en un clic grâce à nos modèles et vos photos.": "Crea una página única con un clic usando nuestras plantillas y tus fotos.",
  "Créez une règle d'aide à la mise en page. Les éléments s'aimanteront dessus.": "Crea una guía de diseño. Los elementos se ajustarán a ella.",
  "Dans le livre": "En el libro",
  "dans le Yearbook": "en el yearbook",
  "de téléphone de la personne qui réceptionnera le(s) colis.": "de la persona que recibirá el/los paquete(s).",
  "Définition / indice": "Definición / pista",
  "Déposez vos photos ici": "Suelta tus fotos aquí",
  "Description": "Descripción",
  "Description disponible": "Descripción disponible",
  "Détail de la remarque…": "Detalles del comentario…",
  "disponible sur la plateforme.": "disponible en la plataforma.",
  "Distance (mm) — max {{max}}": "Distancia (mm) — máx. {{max}}",
  "Donnez un nom à cette page pour mieux l'identifier": "Dale un nombre a esta página para identificarla mejor",
  "Donnez votre note": "Da tu puntuación",
  "Dossier de destination": "Carpeta de destino",
  "Droite": "Derecha",
  "Dupliquer": "Duplicar",
  "Dupliquer la page": "Duplicar la página",
  "Dupliquer la page vers…": "Duplicar la página en…",
  "Échange": "Intercambio",
  "Écrivez votre remarque ici...": "Escribe tu comentario aquí…",
  "Éditer": "Editar",
  "Effacer la recherche": "Borrar búsqueda",
  "Élève / Étudiant": "Alumno / Estudiante",
  "en quelques clics.": "en unos pocos clics.",
  "Enlever le fond de page": "Quitar el fondo de página",
  "Enlever le trombi du livre": "Quitar la orla del libro",
  "Enregistrer": "Guardar",
  "Envoi en cours...": "Enviando...",
  "Envoi en cours…": "Enviando…",
  "Envoi en vérification": "Enviar a revisión",
  "Envoi…": "Enviando…",
  "Envoyé au client": "Enviado al cliente",
  "Envoyé au graphiste": "Enviado al diseñador",
  "Envoyer": "Enviar",
  "Envoyer en impression": "Enviar a imprenta",
  "Envoyer en vérification": "Enviar a revisión",
  "Envoyer le livre au graphiste": "Enviar el libro al diseñador",
  "Envoyer les corrections au client": "Enviar las correcciones al cliente",
  "Envoyer mes remarques aux graphistes": "Enviar mis comentarios a los diseñadores",
  "Envoyer mon avis et lancer l'impression": "Enviar mi opinión y lanzar la impresión",
  "Erreur": "Error",
  "Erreur {{status}}": "Error {{status}}",
  "Erreur lors de l'enregistrement": "Error al guardar",
  "Erreur lors de l'envoi": "Error al enviar",
  "Erreur lors du renommage": "Error al renombrar el álbum",
  "Erreur réseau": "Error de red",
  "Erreur:": "Error:",
  "Est-ce votre premier yearbook avec 1Year1Book ?": "¿Es tu primer yearbook con 1Year1Book?",
  "Établissement": "Centro",
  "Étape {{step}}/{{total}} — {{title}}": "Paso {{step}}/{{total}} — {{title}}",
  "Ex : CM2 - Mme Dupont": "Ej.: 6.º de primaria – Sra. Dupont",
  "Ex : Mots croisés de la promo": "Ej.: Crucigrama de la promoción",
  "Expérience 1Year1Book globale": "Experiencia global con 1Year1Book",
  "Explorez nos yearbooks pour trouver l'inspiration.": "Explora nuestros yearbooks para inspirarte.",
  "Favori": "Favorito",
  "Félicitations ! Votre yearbook part en impression": "¡Enhorabuena! Tu yearbook se va a imprimir",
  "Félicitations, votre livre est envoyé en vérification chez 1Year1Book.": "Enhorabuena, tu libro se ha enviado a 1Year1Book para su revisión.",
  "Fermer": "Cerrar",
  "Fond du bloc": "Fondo del bloque",
  "Fonds": "Fondos",
  "Fonds de page": "Fondos de página",
  "Forcer le retour chez 1Y1B": "Forzar la devolución a 1Y1B",
  "Format et taille": "Formato y tamaño",
  "Formes": "Formas",
  "Gauche": "Izquierda",
  "Génération en cours…": "Generando…",
  "Générer l'album": "Generar el álbum",
  "Générer les modèles": "Generar plantillas",
  "Générer une page": "Generar una página",
  "Générez automatiquement votre album ! Les photos sont placées automatiquement et vous pouvez ensuite les modifier à votre guise.": "¡Genera tu álbum automáticamente! Las fotos se colocan automáticamente y después puedes modificarlas a tu gusto.",
  "Glissez-déposez (png, jpg, jpeg)": "Arrastra y suelta (png, jpg, jpeg)",
  "Glissez-déposez vos photos ici": "Arrastra y suelta tus fotos aquí",
  "Grille vide": "Crucigrama vacío",
  "Gros texte en haut de la page": "Texto grande en la parte superior de la página",
  "Haut": "Arriba",
  "Historique de {{page}}": "Historial de {{page}}",
  "Historique de la page": "Historial de la página",
  "Horizontal": "Horizontal",
  "Import en cours…": "Importando…",
  "Importer des photos": "Importar fotos",
  "Importer mes propres fonds ou mes pages perso": "Importar mis fondos o páginas personales",
  "Impossible d'appliquer le repère à toutes les pages": "No se puede aplicar la guía a todas las páginas",
  "Impossible d'enregistrer le commentaire.": "No se puede guardar el comentario.",
  "Impossible de charger l'historique": "No se puede cargar el historial",
  "Impossible de charger les utilisateurs": "No se pueden cargar los usuarios",
  "Impossible de créer la classe.": "No se puede crear la clase.",
  "Impossible de sauvegarder les mots croisés": "No se puede guardar el crucigrama",
  "Imprimer la page": "Imprimir la página",
  "inconnu": "desconocido",
  "Insérer dans la page": "Insertar en la página",
  "Inspiration": "Inspiración",
  "Internet / Réseaux sociaux": "Internet / Redes sociales",
  "Intervertir": "Intercambiar",
  "Intervertir avec une autre page…": "Intercambiar con otra página…",
  "Intervertir les pages": "Intercambiar páginas",
  "J'ai bien vérifié mon fichier": "He comprobado mi archivo",
  "Je garde la photo": "Conservar esta foto",
  "Je remplace la photo": "Reemplazar esta foto",
  "Je valide": "Confirmar",
  "Je vérifie": "Voy a comprobarlo",
  "L'éditeur en ligne et ses outils.": "El editor en línea y sus herramientas.",
  "L'impression de vos Yearbooks est lancée": "La impresión de tus yearbooks ha comenzado",
  "L'orthographe des textes a bien été vérifiée ?": "¿Se ha comprobado la ortografía de los textos?",
  "La création de l'album remplacera la mise en page actuelle": "La creación del álbum reemplazará el diseño actual",
  "La création du modèle a échoué. Réessayez.": "No se pudo crear la plantilla. Inténtalo de nuevo.",
  "La modification n'a pas pu être enregistrée.": "No se pudo guardar el cambio.",
  "La page {{page}} n'existe pas": "La página {{page}} no existe",
  "Langue": "Idioma",
  "Le plus de photos possible": "El mayor número de fotos posible",
  "Le rendu final de votre livre.": "El resultado final de tu libro.",
  "Le repère sera ajouté à l'ensemble des pages non verrouillées du livre.": "La guía se añadirá a todas las páginas no bloqueadas del libro.",
  "Le yearbook a été validé !": "¡El yearbook ha sido validado!",
  "Les autres pages seront masquées pour elle.": "Las demás páginas se le ocultarán.",
  "Les couleurs de ce fond sont personnalisables": "Los colores de este fondo se pueden personalizar",
  "Les pages seront bientôt disponibles, Raphaëlle vous envoie très prochainement votre facture mise à jour.": "Las páginas estarán disponibles pronto. Raphaëlle te enviará tu factura actualizada en breve.",
  "Les pages supplémentaires s'ajoutent par 4.": "Las páginas adicionales se añaden en bloques de 4.",
  "Les photos deviendront des emplacements vides. Textes, stickers et formes sont conservés.": "Las fotos se convertirán en espacios vacíos. Se conservan los textos, stickers y formas.",
  "Les Yearbooks seront-ils livrés :": "¿Dónde se entregarán los yearbooks?:",
  "Lien": "Enlace",
  "Ligne": "Línea",
  "Liseuse": "Lector",
  "Livraison offerte dés 50€": "Envío gratis desde 50 €",
  "Livre validé": "Libro validado",
  "Marquer une photo pixelisée": "Marcar una foto pixelada",
  "Masquer": "Ocultar",
  "Masquer le panneau": "Ocultar panel",
  "Masquer les commentaires ({{count}})": "Ocultar comentarios ({{count}})",
  "Merci": "Gracias",
  "Merci de noter les 4 critères ci-dessus": "Valora los 4 criterios anteriores",
  "Merci de répondre à toutes les questions obligatoires": "Responde a todas las preguntas obligatorias",
  "Merci pour votre avis !": "¡Gracias por tu opinión!",
  "Merci pour votre commande.": "Gracias por tu pedido.",
  "Mes couleurs enregistrées": "Mis colores guardados",
  "Mes couleurs préférées": "Mis colores favoritos",
  "Mes informations": "Mis datos",
  "Mes photos sont en HD ou à minima de bonnes qualités ?": "¿Mis fotos están en HD o tienen al menos buena calidad?",
  "Message…": "Mensaje…",
  "Mettre le nom ou prénom à la ligne": "Poner el nombre o los apellidos en una nueva línea",
  "Modèle {{current}} / {{total}}": "Plantilla {{current}} / {{total}}",
  "Modèles": "Plantillas",
  "Modifier": "Modificar",
  "Modifier la grille": "Modificar el crucigrama",
  "Modifier la réponse": "Modificar la respuesta",
  "Modifier le format": "Cambiar formato",
  "Modifier le format de mon album": "Cambiar el formato de mi álbum",
  "Modifier le trombi": "Modificar la orla",
  "Modifier mon album": "Modificar mi álbum",
  "Mot": "Palabra",
  "Mots & définitions (min. {{min}})": "Palabras y pistas (mín. {{min}})",
  "Mots croisés": "Crucigramas",
  "Mots non placés": "Palabras no colocadas",
  "🆕 Nouveautés": "🆕 Novedades",
  "Nom": "Apellidos",
  "Nom de l'album": "Nombre del álbum",
  "Nom de l'établissement": "Nombre del centro",
  "Nom de la classe": "Nombre de la clase",
  "Nom de la page": "Nombre de la página",
  "Nom du dossier": "Nombre de la carpeta",
  "Nom du modèle": "Nombre de la plantilla",
  "Nom et prénom du destinataire": "Nombre y apellidos del destinatario",
  "Nom mis à jour": "Nombre actualizado",
  "Nom Prénom": "Apellidos Nombre",
  "Nombre d'échanges avec les graphistes compris dans votre contrat": "Número de intercambios con los diseñadores incluidos en tu contrato",
  "Nombre de pages": "Número de páginas",
  "Non": "No",
  "Non, on remet ça": "No, repetimos",
  "Note…": "Nota…",
  "Notre accompagnement": "Nuestro acompañamiento",
  "Nouvelle étape": "Nueva etapa",
  "Nouvelle grille": "Nuevo crucigrama",
  "Nouvelle grille de mots croisés": "Nuevo crucigrama",
  "Nouvelle remarque": "Nuevo comentario",
  "Nouvelle section": "Nueva sección",
  "Numéro et rue": "Calle y número",
  "Ordre": "Orden",
  "Organisez vos pages par section et suivez l’avancement.": "Organiza tus páginas por secciones y sigue el avance.",
  "Orientation": "Orientación",
  "ou cliquez pour importer depuis votre ordinateur": "o haz clic para importar desde tu ordenador",
  "ou cliquez pour parcourir votre ordinateur": "o haz clic para buscar en tu ordenador",
  "Oui": "Sí",
  "Oui, c'est une première !": "¡Sí, es la primera vez!",
  "Outils de l’éditeur": "Herramientas del editor",
  "Page": "Página",
  "page {{first}} à {{last}}": "páginas {{first}} a {{last}}",
  "page {{page}}": "página {{page}}",
  "Page magique": "Página mágica",
  "page(s)": "página(s)",
  "Pages enregistrées": "Páginas guardadas",
  "Pages visibles par personne, ex.": "Páginas visibles por persona, p. ej.",
  "Par mon école": "A través de mi centro",
  "Paramètres": "Ajustes",
  "Parcourir l'ensemble des designs disponibles": "Explorar todos los diseños disponibles",
  "Parent d'élève / Administration": "Padre o madre / Administración",
  "Pas satisfait": "Nada satisfecho",
  "Paysage": "Horizontal",
  "Personnaliser le trombi": "Personalizar la orla",
  "personne par page_one": "persona por página",
  "personne par page_other": "personas por página",
  "Personnes autorisées :": "Personas autorizadas:",
  "Peu satisfait": "Poco satisfecho",
  "Photos": "Fotos",
  "Photos à vérifier": "Fotos por revisar",
  "Pièce jointe": "Archivo adjunto",
  "Placé sur la page {{page}}": "Colocada en la página {{page}}",
  "Placé sur les pages {{first}} à {{last}}": "Colocada en las páginas {{first}} a {{last}}",
  "Placer « {{name}} »": "Colocar « {{name}} »",
  "Placer dans la page": "Colocar en la página",
  "Police": "Fuente",
  "Portrait": "Vertical",
  "pour": "para",
  "Prénom": "Nombre",
  "Prénom Nom": "Nombre Apellidos",
  "Prénom NOM": "Nombre APELLIDOS",
  "PRÉNOM NOM": "NOMBRE APELLIDOS",
  "Prêt à envoyer 🚀": "Listo para enviar 🚀",
  "Privilégier de grandes photos": "Priorizar las fotos grandes",
  "Prix par Yearbook": "Precio por yearbook",
  "QR Code": "Código QR",
  "Qualité insuffisante": "Calidad insuficiente",
  "Qualité moyenne": "Calidad media",
  "Qualité OK": "Buena calidad",
  "Rechercher un album...": "Buscar un álbum…",
  "Rechercher un sticker…": "Buscar un sticker…",
  "Rechercher une personne…": "Buscar una persona…",
  "Rectangle": "Rectángulo",
  "Réduire le zoom": "Alejar",
  "Refaire": "Rehacer",
  "Refaire (Ctrl+Y)": "Rehacer (Ctrl+Y)",
  "Réinitialiser la page": "Restablecer la página",
  "Réinitialiser le zoom": "Restablecer zoom",
  "Relecture du YearBook": "Revisión del YearBook",
  "Remarques": "Comentarios",
  "Remarques pour les graphistes": "Comentarios para los diseñadores",
  "Remplacer la photo": "Reemplazar la foto",
  "Renommer l'album": "Renombrar álbum",
  "Renommer la page": "Renombrar la página",
  "Repasser en à faire": "Volver a pendientes",
  "Repère ajouté": "Guía añadida",
  "Repère ajouté à toutes les pages": "Guía añadida a todas las páginas",
  "Répondre": "Responder",
  "Réponse": "Respuesta",
  "Retirer": "Quitar",
  "Retirer de la section": "Quitar de la sección",
  "Retirer des favoris": "Quitar de favoritos",
  "Retour": "Volver",
  "Retour sur le site": "Volver al sitio",
  "Retour vers le site": "Volver al sitio",
  "Revenir à cette version": "Volver a esta versión",
  "Sans titre": "Sin título",
  "Satisfaction visuelle du yearbook": "Satisfacción visual del yearbook",
  "Satisfait": "Satisfecho",
  "Sauvegarde automatique": "Guardado automático",
  "Sauvegarde en cours…": "Guardando…",
  "Sauvegarde impossible": "No se puede guardar",
  "Section": "Sección",
  "Sélectionner le nombre de personnes par page puis le design": "Elegir el número de personas por página y después el diseño",
  "Sélectionnez la photo de remplacement.": "Selecciona la foto de reemplazo.",
  "Sélectionnez le nombre de pages à ajouter": "Selecciona el número de páginas que quieres añadir",
  "Seuls les administrateurs peuvent valider ce livre.": "Solo los administradores pueden validar este libro.",
  "Soit un total de": "Un total de",
  "Sous-titre": "Subtítulo",
  "Spread précédent": "Doble página anterior",
  "Spread suivant": "Doble página siguiente",
  "Stickers": "Stickers",
  "Stickers & Formes": "Stickers y formas",
  "Style": "Estilo",
  "Style et disposition": "Estilo y distribución",
  "Suivant": "Siguiente",
  "Suivi client et graphiste.": "Atención al cliente y seguimiento del diseñador.",
  "Suivi des échanges": "Historial de revisiones",
  "Suppression impossible": "No se puede eliminar",
  "Supprimer": "Eliminar",
  "Supprimer ce fond": "Eliminar este fondo",
  "Supprimer ce fond ?": "¿Eliminar este fondo?",
  "Supprimer cette couleur": "Eliminar este color",
  "Supprimer cette photo ?": "¿Eliminar esta foto?",
  "Supprimer cette remarque ?": "¿Eliminar este comentario?",
  "Supprimer cette section ? Les pages ne sont pas supprimées.": "¿Eliminar esta sección? Las páginas no se eliminan.",
  "Supprimer la grille ?": "¿Eliminar este crucigrama?",
  "Sur quelle page appliquer ce modèle ?": "¿En qué página quieres aplicar esta plantilla?",
  "Sur quelle page placer le trombinoscope ?": "¿En qué página quieres colocar la orla?",
  "Taille": "Tamaño",
  "Téléphone": "Teléfono",
  "Texte": "Texto",
  "Texte au milieu de la page": "Texto en el centro de la página",
  "Texte italique sous le titre": "Texto en cursiva debajo del título",
  "Thème": "Tema",
  "Titre": "Título",
  "Titre de la remarque": "Título del comentario",
  "Titre ou thème": "Título o tema",
  "Tous les élèves sont présent·e·s dans le Trombinoscope ?": "¿Están todos los alumnos en el directorio de retratos?",
  "Tout": "Todo",
  "Tout cocher": "Seleccionar todo",
  "Tout décocher": "Deseleccionar todo",
  "Tout retirer": "Quitar todo",
  "Toutes les pages": "Todas las páginas",
  "Tranche": "Lomo",
  "Très satisfait": "Muy satisfecho",
  "Trombi": "Orla",
  "Trombi complet": "Orla completa",
  "Trombi simple": "Orla simple",
  "Trombinoscope": "Orla",
  "Trombinoscope COMPLET (nom + prénom + citation + photo)": "Orla COMPLETA (apellidos + nombre + cita + foto)",
  "Trombinoscope SIMPLE (nom + prénom + photo)": "Orla SIMPLE (apellidos + nombre + foto)",
  "Type de trombinoscope": "Tipo de orla",
  "Un mix de grandes et de petites photos": "Una mezcla de fotos grandes y pequeñas",
  "Un nouveau tour de relecture sera demandé.": "Se solicitará una nueva ronda de revisión.",
  "Une erreur est survenue lors de l'envoi.": "Se produjo un error durante el envío.",
  "Une erreur est survenue.": "Se ha producido un error.",
  "Une erreur réseau est survenue.": "Se ha producido un error de red.",
  "Une suggestion, une amélioration, une fonctionnalité dont vous rêvez…": "Una sugerencia, una mejora, una función que te gustaría…",
  "Une version vous sera envoyée pour validation finale.": "Se te enviará una versión para la validación final.",
  "Uploader un couv.": "Subir portada",
  "Uploader une couverture": "Subir una portada",
  "Validation du livre avant impression": "Validación del libro antes de imprimir",
  "Validé par l'admin": "Validado por el administrador",
  "Validées ({{count}})": "Validados ({{count}})",
  "Valider": "Validar",
  "Valider la commande": "Confirmar el pedido",
  "Valider le livre": "Validar el libro",
  "Vérification des droits…": "Comprobando permisos…",
  "Version {{number}}": "Versión {{number}}",
  "Vertical": "Vertical",
  "Veuillez nous communiquer, s'il vous plaît, l'adresse précise de livraison à laquelle": "Indícanos, por favor, la dirección exacta de entrega a la que",
  "Ville": "Ciudad",
  "Visible par tous les administrateurs de l'album.": "Visible para todos los administradores del álbum.",
  "Voir le suivi des échanges": "Ver el seguimiento de intercambios",
  "Voir les variantes de couleurs": "Ver variantes de color",
  "Voir plus ({{count}} restantes)": "Ver más ({{count}} restantes)",
  "Voir tous les modèles": "Ver todas las plantillas",
  "Vos idées": "Tus ideas",
  "Vos idées nous permettent de toujours mieux vous satisfaire — n'hésitez pas !": "Tus ideas nos ayudan a mejorar — ¡no lo dudes!",
  "Vos retours nous aident à toujours mieux vous accompagner.": "Tus comentarios nos ayudan a acompañarte mejor.",
  "Votre album en 3 clics": "Tu álbum en 3 clics",
  "Votre commentaire (facultatif)": "Tu comentario (opcional)",
  "Votre commentaire…": "Tu comentario…",
  "Votre livre va être envoyé chez les graphistes 1Year1Book pour vérification.": "Tu libro se enviará a los diseñadores de 1Year1Book para su revisión.",
  "Votre message…": "Tu mensaje…",
  "Votre plateforme dédiée": "Tu plataforma dedicada",
  "Votre remarque sera envoyée aux graphistes lors de la vérification de votre Yearbook": "Tu comentario se enviará a los diseñadores durante la revisión de tu yearbook",
  "Votre réponse…": "Tu respuesta…",
  "Votre ressenti général sur l'aventure.": "Tu experiencia general.",
  "Votre satisfaction": "Tu satisfacción",
  "Voulez-vous vraiment réinitialiser cette page ? Tous les éléments seront supprimés.": "¿Quieres restablecer esta página? Se eliminarán todos los elementos.",
  "Vous êtes :": "Eres:",
  "Vous pouvez aussi nous aider en mettant un avis sur Google et/ou Trustpilot !": "¡También puedes ayudarnos dejando una opinión en Google o Trustpilot!",
  "Vous serez tenu informé par email lorsque la version à valider sera": "Te avisaremos por email cuando la versión para validar esté",
  "vous souhaitez que les yearbooks soient livrés, ainsi que les noms, prénoms et numéros": "deseas que se entreguen los yearbooks, así como el nombre, apellidos y teléfono",
  "Vue d'ensemble": "Vista general",
  "Zoom arrière": "Alejar",
  "Zoom avant": "Acercar"
}